const ServicesSection = () => {
  const pillars = [
    {
      icon: 'ri-line-chart-line',
      title: 'Service Cost Capture',
      description: 'Utilization, billing accuracy, and revenue realization',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Project Variance Control',
      description: 'Estimate-to-actual discipline and change order capture',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Pricing & Billing Discipline',
      description: 'Quote-to-invoice integrity and margin preservation',
    },
    {
      icon: 'ri-funds-line',
      title: 'Working Capital Visibility',
      description: 'AR aging, WIP tracking, and cash flow clarity',
    },
    {
      icon: 'ri-building-line',
      title: 'Enterprise Readiness',
      description: 'Preparation for disciplined scale or transition',
    },
  ];

  return (
    <section className="bg-[#FAFAFA] py-48">
      <div className="w-4/5 mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="w-24 h-px bg-[#2B2D33] mx-auto mb-8"></div>
          <h2
            className="text-5xl font-light text-[#2B2D33] leading-tight mb-10 text-center"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            A Disciplined Framework for Margin Integrity
          </h2>

          <p className="text-lg text-[#6B6D72] leading-relaxed mb-20 text-center max-w-3xl mx-auto">
            We examine five interconnected pillars that determine <strong className="text-[#2B2D33]">margin discipline</strong> and enterprise value stability.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {pillars.map((pillar, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                  <i className={`${pillar.icon} text-4xl text-[#2B2D33]`}></i>
                </div>
                <h3 className="text-xl font-medium text-[#2B2D33] mb-3">
                  {pillar.title}
                </h3>
                <p className="text-base text-[#6B6D72] leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
